import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { PROPERTY_OWNERSHIP_V2_API } from "../apiRoutes";
import axiosAuth from "@/services/axiosAuth";

const getOwnershipAccount = async (communityId: string, ownershipId: string) =>
  await axiosAuth.get(`${PROPERTY_OWNERSHIP_V2_API(communityId)}/${ownershipId}/account`);

/** Ownership (title / customer account) detail page payload. */
const useGetOwnershipAccount = ({ communityId, ownershipId }: { communityId: string; ownershipId: string }): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["ownership-account", communityId, ownershipId],
    queryFn: () => getOwnershipAccount(communityId, ownershipId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!communityId && communityId != "all" && !!ownershipId,
  });
};

export default useGetOwnershipAccount;
